/**
 * Generate console colors.
 * @param {string} color
 * @returns {string[]}
 */
function colored(color) {
  return [
    `background: ${color}; padding: 1px; border-radius: 3px 0 0 3px; color: #ffffff`,
    'background: #35495e; padding: 1px; border-radius: 0 3px 3px 0; color: #ffffff',
    'background: transparent',
  ];
}

/**
 * Console wrapper, all except `error` should
 * be used when exact call location isn't needed.
 */
export default class PrettyConsole {
  /**
   * Output an info message.
   * @param {string} message
   */
  static info(message) {
    console.info(`%c info %c ${message} %c`, ...colored('#2864c7'));
  }

  /**
   * Output a debug message.
   * @param {string} context
   * @param {string} message
   * @param {*} payload
   */
  static debug(context, message, ...payload) {
    console.debug(`%c ${context} %c ${message} %c`, ...colored('#c17f26'), ...payload);
  }

  /**
   * Output an error message.
   * @param {string} message
   * @param {*} payload
   */
  static error(message, ...payload) {
    console.error(`%c error %c ${message} %c`, ...colored('#af1919'), ...payload);
  }
}
